import React from "react";
import ReactDOM from "react-dom/client";
// Must run BEFORE React mounts so patched Node methods are live during the
// very first render — fixes browser-translation DOM conflicts.
import "@/lib/gtranslate-patch";
import "@/index.css";
import App from "@/App";
import { initAnalytics } from "@/lib/analytics";

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
